export default __webpack_public_path__ + "images/api_key_v2_intro_2-p0AwK.png";